module.exports = __webpack_public_path__ + "img/man.fa42b009.png";